const RESERVED_SUBDOMAINS = new Set(["www", "app", "admin", "api"]);

const isIPv4Host = (host) => /^\d{1,3}(\.\d{1,3}){3}$/.test(host);

// Single-tenant mode configuration
const SINGLE_TENANT_MODE = process.env.REACT_APP_SINGLE_TENANT_MODE === "true";
const SINGLE_TENANT_SLUG = process.env.REACT_APP_TENANT_SLUG || null;

export function getTenantFromHost(hostname = window.location.hostname) {
  // In single-tenant mode, always return the configured tenant
  if (SINGLE_TENANT_MODE && SINGLE_TENANT_SLUG) {
    return SINGLE_TENANT_SLUG;
  }

  if (!hostname || typeof hostname !== "string") {
    return null;
  }

  const host = hostname.toLowerCase().split(":")[0];

  if (host === "localhost" || isIPv4Host(host)) {
    return null;
  }

  const parts = host.split(".").filter(Boolean);

  if (parts.length < 3) {
    return null;
  }

  const candidate = parts[0];
  if (!candidate || RESERVED_SUBDOMAINS.has(candidate)) {
    return null;
  }

  return candidate;
}

export function resolveTenantId() {
  const subdomainTenant = getTenantFromHost();
  if (subdomainTenant) {
    return subdomainTenant;
  }

  const companyData = localStorage.getItem("company");
  if (companyData) {
    try {
      const company = JSON.parse(companyData);
      if (company?.slug) {
        return String(company.slug).toLowerCase();
      }
    } catch (error) {
      console.error("Error parsing company data:", error);
    }
  }

  return null;
}

const getBaseDomain = (hostname) => {
  const configured = process.env.REACT_APP_TENANT_PARENT_DOMAIN;
  if (configured && typeof configured === "string") {
    return configured.toLowerCase().trim();
  }

  const host = String(hostname || "").toLowerCase();
  const parts = host.split(".").filter(Boolean);

  if (parts.length < 2) {
    return null;
  }

  return parts.slice(-2).join(".");
};

export function buildTenantRedirectUrl(tenantSlug) {
  // In single-tenant mode, never redirect to subdomains
  if (SINGLE_TENANT_MODE) {
    return null;
  }

  const slug = String(tenantSlug || "")
    .toLowerCase()
    .trim();
  if (!slug || RESERVED_SUBDOMAINS.has(slug)) {
    return null;
  }

  if (typeof window === "undefined") {
    return null;
  }

  const currentHost = window.location.hostname.toLowerCase();
  if (currentHost === "localhost" || isIPv4Host(currentHost)) {
    return null;
  }

  const baseDomain = getBaseDomain(currentHost);
  if (!baseDomain) {
    return null;
  }

  const targetHost = `${slug}.${baseDomain}`;
  if (currentHost === targetHost) {
    return null;
  }

  return `${window.location.protocol}//${targetHost}/`;
}
